module.exports = __webpack_public_path__ + "static/media/Dus Ka Dum.806bb35b.jpg";